import { spacing } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { motion } from "framer-motion";
import styled from "styled-components";
import { insetSquished } from "../../../mixins/inset";
import outerLayoutMixin from "../../../mixins/outerLayout";
import buttonBaseStyle from "./buttonBaseStyle";
export const Button = styled(motion.button) `
  ${buttonBaseStyle};
  ${insetSquished("m")};
  ${outerLayoutMixin};

  &.block {
    display: grid;
    width: 100%;
  }

  &.iconOnly {
    padding: ${spacing.base.s};
  }
`;
export default Button;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQnV0dG9uL3N0eWxlZC9CdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUN6RSxPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQ3ZDLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSx1QkFBdUIsQ0FBQztBQUN0RCxPQUFPLGdCQUVOLE1BQU0sNkJBQTZCLENBQUM7QUFDckMsT0FBTyxlQUFlLE1BQU0sbUJBQW1CLENBQUM7QUFFaEQsTUFBTSxDQUFDLE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQXVCO0lBQzlELGVBQWU7SUFDZixhQUFhLENBQUMsR0FBRyxDQUFDO0lBQ2xCLGdCQUFnQjs7Ozs7Ozs7ZUFRTCxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7O0NBRTVCLENBQUM7QUFFRixlQUFlLE1BQU0sQ0FBQyJ9